import { ModalSelect } from './../../dynamic-form/shared/controls/modal-select';
import { Custom } from './../../dynamic-form/shared/controls/custom';
import { DateTimePicker } from './../../dynamic-form/shared/controls/datetimepicker';
import { Textbox } from './../../dynamic-form/shared/controls/textbox';
import { TextArea } from './../../dynamic-form/shared/controls/textarea';
import { Container } from './../../dynamic-form/shared/controls/container';
import { Static } from './../../util/static';
import { BaseControl } from './../../dynamic-form/shared/controls/base-control';
import { ColumnaMaestra } from './../../models/tabla-maestra.model';
import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { Partial, find } from 'lodash';

@Injectable()
export class RefactoryMasterTableFormService {
  constructor() {}

  /**
   * Crea el formulario dinamico de la tabla maestra dinamica
   *
   * @param {ColumnaMaestra[]} columns
   * @param {*} templetesForm
   * @param {*} [data]
   * @returns {BaseControl<any>[]}
   * @memberof RefactoryMasterTableFormService
   */
  getFieldsDynamicTableStructure(columnsI: ColumnaMaestra[], templetesForm: any, data?: any): BaseControl<any>[] {
    const columns = Static.copyObjet(columnsI) as ColumnaMaestra[];
    const controls: BaseControl<any>[] = [new Container({
      class: 'form-row form-check form-check-inline col-12',
      order: 1,
      controls: [ ]
    })];

    columns.forEach(field => {
      let value: any = null;
        if (data) {
          if (typeof data[field.id + ' '] !== 'undefined') {
            value = data[field.id + ' '];
          }
        }
      if (field.validaciones && field.validaciones.condiciones && field.validaciones.condiciones.length) {
        field.validaciones.condiciones.forEach(condiction => {
          const col = find(columns, {alias: condiction.campoDepende});
          if (col) {
            condiction.campoDepende = col.id + ' ';
          }
        });
      }
      const temp = {
        form: columns,
        control: field
      };
      controls[0]['controls'].push(this.getControl(field, templetesForm, value, temp));
    });

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Crea el control de pendiendo del tipo
   *
   * @param {ColumnaMaestra} control
   * @param {*} templetesFomr
   * @param {*} [value]
   * @param {*} [dataTemp]
   * @returns {BaseControl<Partial>}
   * @memberof RefactoryMasterTableFormService
   */
  getControl(
    control: ColumnaMaestra,
    templetesFomr: any,
    value?: any,
    dataTemp?: any): BaseControl<Partial> {
    let field: any;
    switch (control.tipo_campo['nombre']) {
      case 'textarea':
        const textArea: TextArea = new TextArea({
          key: control.id + ' ',
          label: control.nombre,
          size: 'col-md-' + control.espacio,
          rows: control.propiedades['rows'],
          placeholder: control.placeholder,
          value: '',
          order: control.orden + 1,
          transform: control.propiedades['transform'] ? control.propiedades['transform'] : 'ninguna',
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
          condictions: control.validaciones ?
                        control.validaciones.condiciones ?
                          control.validaciones.condiciones :
                        [] :
                       [],
        });
        if (control.requerido) {
          textArea.validations.validators.push(Validators.required);
        }

        if (control.propiedades['max']) {
          textArea.validations.validators.push(Validators.maxLength(control.propiedades['max']));
          textArea.validations
            .messages['maxlength'] = 'El numero máximo de caracteres es de ' + control.propiedades['max'];
        }

        if (control.propiedades['min']) {
          textArea.validations.validators.push(Validators.minLength(control.propiedades['min']));
          textArea.validations
            .messages['minlength'] = 'El numero mínimo de caracteres es de ' + control.propiedades['min'];
        }

        field = textArea;
        break;
      case 'email':
        const email: Textbox = new Textbox({
          key: control.id + ' ',
          label: control.nombre,
          type: control.tipo_campo['nombre'],
          value: '',
          order: control.orden + 1,
          placeholder: control.placeholder,
          size: 'col-md-' + control.espacio,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
          validations: {
            validators: [],
            messages: {}
          },
          condictions: control.validaciones ?
                        control.validaciones.condiciones ?
                          control.validaciones.condiciones :
                        [] :
                       [],
        });
        if (control.requerido) {
          email.validations.validators.push(Validators.required);
        }

        if (control.propiedades['expresion']) {
          email.validations.validators.push(Validators.pattern(control.propiedades['expresion']));
          if (control.propiedades['mensajeExpresion']) {
            email.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
          }
        } else {
          email.validations.validators.push(Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/));
          if (control.propiedades['mensajeExpresion']) {
            email.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
          } else {
            email.validations.messages['pattern'] = 'Ingrese un email válido';
          }
        }

        field = email;
        break;
      case 'date-time-picker':
        const date: DateTimePicker = new DateTimePicker({
          key: control.id + ' ',
          label: control.nombre,
          order: control.orden + 1,
          value: null,
          size: 'col-md-' + control.espacio,
          pickerMode: 'dialog',
          placeholder: control.placeholder,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
          condictions: control.validaciones ?
                        control.validaciones.condiciones ?
                          control.validaciones.condiciones :
                        [] :
                       [],
        });
        if (control.requerido) {
          date.validations.validators.push(Validators.required);
        }

        if (control.propiedades['fechaDesde']) {
          date.minDate = control.propiedades['fechaDesde'];
        }

        if (control.propiedades['fechaHasta']) {
          date.maxDate = control.propiedades['fechaHasta'];
        }

        switch (control.propiedades['tipo']) {
          case 'calendar':
            date.pickerType = 'calendar';
            break;
          case 'timer':
            date.pickerType = 'timer';
            break;
          case 'range':
            date.selectMode = 'range';
            break;
          case 'rangeTime':
            date.pickerType = 'timer';
            date.selectMode = 'range';
            break;
          case 'rangeDate':
            date.pickerType = 'calendar';
            date.selectMode = 'range';
            break;
        }
        field = date;
        break;
      case 'ngSelect':
        let valueF: any = null;
        if (control.propiedades['options'] && control.propiedades['options'].length) {
          for (const option of control.propiedades['options']) {
            if (value === option.value) {
              valueF = value;
              break;
            }
          }
        }
        let ngSelect: Custom | ModalSelect;
        if (!control.propiedades['tipoSelector'] || control.propiedades['tipoSelector'] === 'EnLista') {
          ngSelect = new Custom({
            key: control.id + ' ',
            label: control.nombre,
            order: control.orden + 1,
            size: 'col-md-' + control.espacio,
            template: templetesFomr.ngSelectTpl,
            placeholder: control.placeholder,
            value: valueF,
            options: control.propiedades['options'],
            readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            validations: {
              validators: []
            },
            condictions: control.validaciones ?
                          control.validaciones.condiciones ?
                            control.validaciones.condiciones :
                          [] :
                          [],
          });
        } else {
          let temp = {};
          if (control.maestra_dependencia && typeof control.maestra_dependencia === 'object') {
            control.maestra_dependencia.estructura.sort((a, b) => a.orden - b.orden);
            temp = Static.copyObjet(control.maestra_dependencia);
          }
          if (dataTemp) {
            Object.keys(dataTemp).forEach(key => {
              temp[key] = dataTemp[key];
            });
          }
          ngSelect = new ModalSelect({
            key: control.id + ' ',
            label: control.nombre,
            order: control.orden + 1,
            size: 'col-md-' + control.espacio,
            placeholder: control.placeholder,
            disabled: control.propiedades['bloquear'] ? control.propiedades['bloquear'] : false,
            value: valueF,
            readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
            validations: {
              validators: []
            },
            condictions: control.validaciones.condiciones,
            tmpParameter: temp,
            data: control ?
                    control.propiedades ?
                      control.propiedades['dataSelectorModal'] ?
                        control.propiedades['dataSelectorModal']
                      : []
                    : []
                  : [],
            columns: control ?
                      control.propiedades ?
                        control.propiedades['columnsSelectorModal'] ?
                          control.propiedades['columnsSelectorModal']
                        : []
                      : []
                     : [],
            keyValue: 'id',
            classModal: 'modal-lg-personalized',
            actionAdd: control ?
                        control.propiedades ?
                          control.propiedades['accionesInModal'] ?
                            control.propiedades['accionesInModal']['agregarInModal'] ?
                              control.propiedades['accionesInModal']['agregarInModal']
                            : false
                          : false
                        : false
                       : false,
            actionUpdate: control ?
                            control.propiedades ?
                              control.propiedades['accionesInModal'] ?
                                control.propiedades['accionesInModal']['modificarInModal'] ?
                                  control.propiedades['accionesInModal']['modificarInModal']
                                : false
                              : false
                            : false
                          : false,
            actionDelete: control ?
                            control.propiedades ?
                              control.propiedades['accionesInModal'] ?
                                control.propiedades['accionesInModal']['eliminarInModal'] ?
                                  control.propiedades['accionesInModal']['eliminarInModal']
                                : false
                              : false
                            : false
                          : false,
          });
        }
        if (control.requerido) {
          ngSelect.validations.validators.push(Validators.required);
        }
        field = ngSelect;
        break;
      case 'number':
        const number: Textbox = new Textbox({
          key: control.id + ' ',
          label: control.nombre,
          type: control.tipo_campo['nombre'],
          value: '',
          order: control.orden + 1,
          placeholder: control.placeholder,
          size: 'col-md-' + control.espacio,
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
          condictions: control.validaciones ?
                        control.validaciones.condiciones ?
                          control.validaciones.condiciones :
                        [] :
                       [],
        });
        if (control.requerido) {
          number.validations.validators.push(Validators.required);
        }

        if (control.propiedades['max']) {
          if (!control.propiedades['menorQue']) {
            number.validations.validators.push(Validators.max(control.propiedades['max']));
            number.validations.messages['max'] = 'Debe ser menor o igual a ' + control.propiedades['max'] + '.';
          } else {
            number.customMax = control.propiedades['max'];
            number.validations.messages['customMax'] = 'Debe ser menor a ' + control.propiedades['max'] + '.';
          }
        }

        if (control.propiedades['min']) {
           if (!control.propiedades['mayorQue']) {
            number.validations.validators.push(Validators.min(control.propiedades['min']));
            number.validations.messages['min'] = 'Debe ser mayor o igual a ' + control.propiedades['min'] + '.';
          } else {
            number.customMin = control.propiedades['min'];
            number.validations.messages['customMin'] = 'Debe ser mayor a ' + control.propiedades['min'] + '.';
          }
        }

        if (control.propiedades['cantidadDecimales']) {
          number.customDecimalMax = control.propiedades['cantidadDecimales'];
          number.validations.messages['customDecimalMax'] = 'Máximo ' + control.propiedades['cantidadDecimales'] +
                                                            ' decimales permitidos.';
        }

        if (!control.propiedades['enteros']) {
          if (control.propiedades['expresion']) {
            number.validations.validators.push(Validators.pattern(control.propiedades['expresion']));
            if (control.propiedades['mensajeExpresion']) {
              number.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
            }
          }
        } else {
          number.validations.validators.push(Validators.pattern(/^-?\d+$/));
          number.validations.messages['pattern'] = 'Solo numeros enteros';
        }

        field = number;
        break;
      case 'label':
        const label: Custom = new Custom({
          key: control.id + ' ',
          order: control.orden + 1,
          size: 'col-md-' + control.espacio,
          sizeFont: control.propiedades['sizeFont'],
          template: templetesFomr.labelTpl,
          hiddenLabel: true,
          label: control.nombre,
          condictions: control.validaciones ?
                        control.validaciones.condiciones ?
                          control.validaciones.condiciones :
                        [] :
                       [],
        });
        field = label;
        break;
      default:
        const text: Textbox = new Textbox({
          key: control.id + ' ',
          label: control.nombre,
          type: control.tipo_campo['nombre'],
          value: '',
          order: control.orden + 1,
          placeholder: control.placeholder,
          size: 'col-md-' + control.espacio,
          transform: control.propiedades['transform'] ? control.propiedades['transform'] : 'ninguna',
          readonly: control.propiedades['redonly'] ? control.propiedades['redonly'] : false,
          condictions: control.validaciones ?
                        control.validaciones.condiciones ?
                          control.validaciones.condiciones :
                        [] :
                       [],
        });
        if (control.requerido) {
          text.validations.validators.push(Validators.required);
        }

        if (control.propiedades['max']) {
          text.validations.validators.push(Validators.maxLength(control.propiedades['max']));
          text.validations.messages['maxlength'] = 'El numero máximo de caracteres es de ' + control.propiedades['max'];
        }

        if (control.propiedades['min']) {
          text.validations.validators.push(Validators.minLength(control.propiedades['min']));
          text.validations.messages['minlength'] = 'El numero mínimo de caracteres es de ' + control.propiedades['min'];
        }

        if (control.propiedades['expresion']) {
          text.validations.validators.push(Validators.pattern(control.propiedades['expresion']));
          if (control.propiedades['mensajeExpresion']) {
            text.validations.messages['pattern'] = control.propiedades['mensajeExpresion'];
          }
        }

        if (
          control.propiedades['default'] &&
          control.propiedades['default'] === 'seleccionado' &&
          value === null
        ) {
          text.default = true;
        }

        field = text;
        break;
    }
    if (value && typeof control.tipo_campo === 'object' && control.tipo_campo.nombre !== 'ngSelect') {
      field['value'] = value;
    }
    return field;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/refactory-master-table/shared/refactory-master-table.form.service.ts